import React, { useState } from 'react'
import { IoClose } from 'react-icons/io5'
import BusinessType from '../BusinessType/BusinessType'
import BusinessDetails from '../BusinessDetails/BusinessDetails'
import { useNavigate } from 'react-router-dom'
import BusinessRepresent from '../BusinessRepresent/BusinessRepresent'
import BusinessOwners from '../BusinessOwners/BusinessOwners'
import BankDetails from '../BankDetails/BankDetails'
import SecureAccount from '../SecureAccount/SecureAccount'
import PublicDetails from '../PublicDetails/PublicDetails'
import StepSummary from '../StepSummary/StepSummary'
import { Progress } from '@material-tailwind/react'
import FullfillDetails from '../FullfillDetails/FullfillDetails'
import TaxCalculation from '../TaxCalculation/TaxCalculation'
import ClimateStep from '../ClimateStep/ClimateStep'
import { IoIosCheckmark } from 'react-icons/io'

const ActivePayment = () => {
    const [mainStep, setMainStep] = useState('step1')
    const [step, setStep] = useState('details')
    const [isUpdate, setIsUpdate] = useState(false)
    const [data, setData] = useState('default')
    const [businessType, setBusinessType] = useState({
        business_location: "United States",
        type_of_business: 'Company',
        business_structure: 'Sole proprietorship'
    })
    const [businessDetail, setBusinessDetail] = useState({
        business_name: '',
        business_indentification_number: '111',
        business_country: "United States",
        business_address1: '',
        business_address2: '',
        business_city: '',
        business_state: '',
        zip: '',
        business_phone_number: '',
        industry: 'Please select your industry…',
        business_website: '',
        product_description: ''
    })
    const [businessRepresent, setBusinessRepresent] = useState({
        representative_first_name: '',
        representative_last_name: '',
        representative_email: localStorage.getItem("email"),
        representative_job_title: '',
        representative_country: "United States",
        representative_address1: '',
        representative_address2: '',
        representative_city: '',
        representative_state: '',
        representative_zip: '',
        representative_phone_number: '',
        representative_social_sequrity_number: ''
    })
    const [businessOwner, setBusinessOwner] = useState({
        owner_first_name: '',
        owner_last_name: '',
        owner_email: ''
    })
    const [fullfillmentDetail, setFullfillmentDetail] = useState({
        is_physical_goods: 'no',
        recive_goods_services: ''
    })
    const [publicDetail, setPublicDetail] = useState({
        statement_descriptor: '',
        shortened_descriptor: '',
        customer_suport_phone: '',
        customer_suport_country: "United States",
        customer_suport_address1: '',
        customer_suport_address2: '',
        customer_suport_city: '',
        customer_suport_state: '',
        customer_suport_zip: ''
    })
    const [bankDetail, setBankDetail] = useState({
        routing_number: '',
        account_number: '',
        confirm_account_number: ''
    })
    const [secureAccount, SetSecureAccount] = useState({
        account_secure_method: ''
    })

    const navigate = useNavigate()

    return (
        <>
            <div>
                <div className="p-[20px] flex sm:items-center bg-white sm:flex-row sticky top-0 z-30 flex-col gap-2 justify-between border-b-[1px] border-[#ebeef1]">
                    <div className="flex items-center">
                        <button onClick={() => navigate('/dashboard')} className="border-r-[1px] border-gray-400 pr-[15px] mr-[15px]">
                            <IoClose className='text-gray-700 text-[18px]' />
                        </button>
                        <div>
                            <span className="text-sm font-medium text-[#414552]">Activate payments</span>
                            <span className='py-[1px] px-[6px] text-[#513DD9] bg-[#F2EBFF] text-[12px] font-[500] rounded-[4px] ml-[8px]'>In progress</span>
                        </div>
                    </div>
                </div>
                <div>
                    <div className='w-full lg:flex bg-[#f6f8fa] lg:mt-0 mt-[50px]'>
                        <div className='max-w-[310px] p-[48px] w-full h-[calc(100vh-65px)] overflow-y-auto bg-white lg:block hidden'>
                            <div>
                                <ul>
                                    <li>
                                        <div className='h-auto flex'>
                                            <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[10px] rounded-t-[16px]'>
                                                <div className={`w-[20px] h-[20px] ${mainStep === "step1" ? "bg-[#625afa]" : "bg-[#687385]"} text-[#fff] rounded-full m-auto flex justify-center items-center`}>1</div>
                                            </div>
                                            <div onClick={() => { setMainStep('step1'); setStep('details'); setIsUpdate(false) }} className='ml-[12px] mt-[3px] cursor-pointer'>
                                                <h3 className='text-sm text-[#414552] font-bold'>Verify your business</h3>
                                            </div>
                                        </div>
                                    </li>
                                    {mainStep === 'step1' && <>
                                        <li>
                                            <div className='h-auto flex'>
                                                <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[8px]'>
                                                    <div className={`w-[6px] h-[6px] ${step === 'type' ? 'bg-[#625afa]' : 'bg-[#a3acba]'} rounded-full my-[8px] mx-auto flex justify-center items-center`}></div>
                                                </div>
                                                <div onClick={() => {setStep('type'); setIsUpdate(false)}} className='ml-[26px] mt-[3px] cursor-pointer'>
                                                    <h3 className={`text-sm ${step === 'type' ? 'text-[#625afa] font-bold' : 'font-semibold text-[#687385]'} font-bold`}>Business type</h3>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='h-auto flex'>
                                                <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[8px]'>
                                                    <div className={`w-[6px] h-[6px] ${step === 'details' ? 'bg-[#625afa]' : 'bg-[#a3acba]'} rounded-full my-[8px] mx-auto flex justify-center items-center`}></div>
                                                </div>
                                                <div onClick={() => {setStep('details'); setIsUpdate(false)}} className='ml-[26px] mt-[3px] cursor-pointer'>
                                                    <h3 className={`text-sm ${step === 'details' ? 'text-[#625afa] font-bold' : 'font-semibold text-[#687385]'} font-bold`}>Business details</h3>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='h-auto flex'>
                                                <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[8px]'>
                                                    <div className={`w-[6px] h-[6px] ${step === 'representative' ? 'bg-[#625afa]' : 'bg-[#a3acba]'} rounded-full my-[8px] mx-auto flex justify-center items-center`}></div>
                                                </div>
                                                <div onClick={() => {setStep('representative'); setIsUpdate(false)}} className='ml-[26px] mt-[3px] cursor-pointer'>
                                                    <h3 className={`text-sm ${step === 'representative' ? 'text-[#625afa] font-bold' : 'font-semibold text-[#687385]'} font-bold`}>Business representative</h3>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='h-auto flex'>
                                                <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[8px]'>
                                                    <div className={`w-[6px] h-[6px] ${step === 'owners' ? 'bg-[#625afa]' : 'bg-[#a3acba]'} rounded-full my-[8px] mx-auto flex justify-center items-center`}></div>
                                                </div>
                                                <div onClick={() => {setStep('owners'); setIsUpdate(false)}} className='ml-[26px] mt-[3px] cursor-pointer'>
                                                    <h3 className={`text-sm ${step === 'owners' ? 'text-[#625afa] font-bold' : 'font-semibold text-[#687385]'} font-bold`}>Business owners</h3>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='h-auto flex'>
                                                <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[8px]'>
                                                    <div className={`w-[6px] h-[6px] ${step === 'fullfill' ? 'bg-[#625afa]' : 'bg-[#a3acba]'} rounded-full my-[8px] mx-auto flex justify-center items-center`}></div>
                                                </div>
                                                <div onClick={() => {setStep('fullfill'); setIsUpdate(false)}} className='ml-[26px] mt-[3px] cursor-pointer'>
                                                    <h3 className={`text-sm ${step === 'fullfill' ? 'text-[#625afa] font-bold' : 'font-semibold text-[#687385]'} font-bold`}>Fullfillment details</h3>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div className='h-auto flex'>
                                                <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[8px]'>
                                                    <div className={`w-[6px] h-[6px] ${step === 'public' ? 'bg-[#625afa]' : 'bg-[#a3acba]'} rounded-full my-[8px] mx-auto flex justify-center items-center`}></div>
                                                </div>
                                                <div onClick={() => {setStep('public'); setIsUpdate(false)}} className='ml-[26px] mt-[3px] cursor-pointer'>
                                                    <h3 className={`text-sm ${step === 'public' ? 'text-[#625afa] font-bold' : 'font-semibold text-[#687385]'} font-bold`}>Public details</h3>
                                                </div>
                                            </div>
                                        </li>
                                    </>
                                    }
                                    <li>
                                        <div className='h-auto flex'>
                                            <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[10px]'>
                                                <div className={`w-[20px] h-[20px] ${mainStep === "step2" ? "bg-[#625afa]" : "bg-[#687385]"} text-[#fff] rounded-full m-auto flex justify-center items-center`}> 2</div>
                                            </div>
                                            <div onClick={() => { setMainStep('step2'); setStep('bank-detail'); setIsUpdate(false) }} className='ml-[12px] mt-[3px] cursor-pointer'>
                                                <h3 className='text-sm text-[#414552] font-bold'>Add your bank</h3>
                                            </div>
                                        </div>
                                    </li>
                                    {mainStep === 'step2' &&
                                        <li>
                                            <div className='h-auto flex'>
                                                <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[8px]'>
                                                    <div className={`w-[6px] h-[6px] ${step === 'bank-detail' ? 'bg-[#625afa]' : 'bg-[#a3acba]'} rounded-full my-[8px] mx-auto flex justify-center items-center`}></div>
                                                </div>
                                                <div onClick={() => {setStep('bank-detail'); setIsUpdate(false)}} className='ml-[26px] mt-[3px] cursor-pointer'>
                                                    <h3 className={`text-sm ${step === 'bank-detail' ? 'text-[#625afa] font-bold' : 'font-semibold text-[#687385]'} font-bold`}>Bank details</h3>
                                                </div>
                                            </div>
                                        </li>
                                    }
                                    <li>
                                        <div className='h-auto flex'>
                                            <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[10px]'>
                                                <div className={`w-[20px] h-[20px] ${mainStep === "step3" ? "bg-[#228403]" : "bg-[#228403]"} text-[#fff] rounded-full m-auto flex justify-center items-center`}><IoIosCheckmark className='text-[22px]' /></div>
                                            </div>
                                            <div onClick={() => { setMainStep('step3'); setStep('varification'); setIsUpdate(false) }} className='ml-[12px] mt-[3px] cursor-pointer'>
                                                <h3 className='text-sm text-[#414552] font-bold'>Secure your account</h3>
                                            </div>
                                        </div>
                                    </li>
                                    {mainStep === 'step3' &&
                                        <li>
                                            <div className='h-auto flex'>
                                                <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[8px]'>
                                                    <div className={`w-[6px] h-[6px] ${step === 'varification' ? 'bg-[#625afa]' : 'bg-[#a3acba]'} rounded-full my-[8px] mx-auto flex justify-center items-center`}></div>
                                                </div>
                                                <div onClick={() => {setStep('varification'); setIsUpdate(false)}} className='ml-[26px] mt-[3px] cursor-pointer'>
                                                    <h3 className={`text-sm ${step === 'varification' ? 'text-[#625afa] font-bold' : 'font-semibold text-[#687385]'} font-bold`}>Two-step authentication</h3>
                                                </div>
                                            </div>
                                        </li>
                                    }
                                    <li>
                                        <div className='h-auto flex'>
                                            <div className={`w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[10px]`}>
                                                <div className={`w-[20px] h-[20px] ${mainStep === "step4" ? "bg-[#625afa]" : "bg-[#687385]"} text-[#fff] rounded-full m-auto flex justify-center items-center`}>4</div>
                                            </div>
                                            <div onClick={() => { setMainStep('step4'); setStep('taxCalc'); setIsUpdate(false) }} className='ml-[12px] mt-[3px] cursor-pointer'>
                                                <h3 className='text-sm text-[#414552] font-bold'>Add extras</h3>
                                            </div>
                                        </div>
                                    </li>
                                    {mainStep === 'step4' &&
                                        <>
                                            <li>
                                                <div className='h-auto flex'>
                                                    <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[8px]'>
                                                        <div className={`w-[6px] h-[6px] ${step === 'taxCalc' ? 'bg-[#625afa]' : 'bg-[#a3acba]'} my-[8px] mx-auto rounded-full flex justify-center items-center`}></div>
                                                    </div>
                                                    <div onClick={() => {setStep('taxCalc'); setIsUpdate(false)}} className='ml-[26px] mt-[3px] cursor-pointer'>
                                                        <h3 className={`text-sm ${step === 'taxCalc' ? 'text-[#625afa] font-bold' : 'font-semibold text-[#687385]'} font-bold`}>Tax calculation</h3>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className='h-auto flex'>
                                                    <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[8px]'>
                                                        <div className={`w-[6px] h-[6px] ${step === 'climate' ? 'bg-[#625afa]' : 'bg-[#a3acba]'} my-[8px] rounded-full mx-auto flex justify-center items-center`}></div>
                                                    </div>
                                                    <div onClick={() => {setStep('climate'); setIsUpdate(false)}} className='ml-[26px] mt-[3px] cursor-pointer'>
                                                        <h3 className={`text-sm ${step === 'climate' ? 'text-[#625afa] font-bold' : 'font-semibold text-[#687385]'} font-bold`}>Climate contributions</h3>
                                                    </div>
                                                </div>
                                            </li>
                                        </>
                                    }
                                    <li>
                                        <div className='h-auto flex'>
                                            <div className={`${mainStep === "step5" ? "pb-[10px]" : "pb-[4px] rounded-b-full"} w-full max-w-[26px] bg-[#ebeef1] p-[3px]`}>
                                                <div className={`w-[20px] h-[20px] ${mainStep === "step5" ? "bg-[#625afa]" : "bg-[#687385]"} text-[#fff] rounded-full m-auto flex justify-center items-center`}>5</div>
                                            </div>
                                            <div onClick={() => { setMainStep('step5'); setStep('Summary'); setIsUpdate(false) }} className='ml-[12px] mt-[3px] cursor-pointer'>
                                                <h3 className='text-sm text-[#414552] font-bold'>Review and finish</h3>
                                            </div>
                                        </div>
                                    </li>
                                    {mainStep === 'step5' &&
                                        <li>
                                            <div className='h-auto flex'>
                                                <div className='w-full max-w-[26px] bg-[#ebeef1] p-[3px] pb-[8px] rounded-b-full'>
                                                    <div className={`w-[6px] h-[6px] ${step === 'Summary' ? 'bg-[#625afa]' : 'bg-[#a3acba]'} rounded-full my-[8px] mx-auto flex justify-center items-center`}></div>
                                                </div>
                                                <div onClick={() => setStep('Summary')} className='ml-[26px] mt-[3px] cursor-pointer'>
                                                    <h3 className={`text-sm ${step === 'Summary' ? 'text-[#625afa] font-bold' : 'font-semibold text-[#687385]'} font-bold`}>Summary</h3>
                                                </div>
                                            </div>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className='lg:w-[calc(100%-310px)] w-full flex-col flex lg:h-[calc(100vh-65px)] h-fit overflow-y-auto z-0 lg:items-start items-center'>
                            <div className='lg:hidden block mb-3 relative z-20 max-w-[140px] w-full'>
                                <Progress value={20} className='h-[8px]' color="indigo" />
                            </div>
                            <div className="max-w-[460px] h-full relative w-full z-10 lg:p-[40px_40px_40px_10px] p-[20px]">
                                {step === "type" && (
                                    <BusinessType
                                        setStep={setStep}
                                        businessType={businessType}
                                        setBusinessType={setBusinessType}
                                    />
                                )}
                                {step === "details" && (
                                    <BusinessDetails
                                        setStep={setStep}
                                        setMainStep={setMainStep}
                                        businessDetail={businessDetail}
                                        setBusinessDetail={setBusinessDetail}
                                        isUpdate={isUpdate}
                                        setData={setData}
                                    />
                                )}
                                {step === "representative" && (
                                    <BusinessRepresent
                                        setStep={setStep}
                                        setMainStep={setMainStep}
                                        businessRepresent={businessRepresent}
                                        setBusinessRepresent={setBusinessRepresent}
                                        isUpdate={isUpdate}
                                        setData={setData}
                                    />
                                )}
                                {step === "owners" && (
                                    <BusinessOwners
                                        setStep={setStep}
                                        setMainStep={setMainStep}
                                        businessOwner={businessOwner}
                                        setBusinessOwner={setBusinessOwner}
                                        isUpdate={isUpdate}
                                        setData={setData}
                                    />
                                )}
                                {step === "fullfill" && (
                                    <FullfillDetails
                                        setStep={setStep}
                                        setMainStep={setMainStep}
                                        fullfillmentDetail={fullfillmentDetail}
                                        setFullfillmentDetail={setFullfillmentDetail}
                                        isUpdate={isUpdate}
                                        setData={setData}
                                    />
                                )}
                                {step === "public" && (
                                    <PublicDetails
                                        setStep={setStep}
                                        setMainStep={setMainStep}
                                        publicDetail={publicDetail}
                                        setPublicDetail={setPublicDetail}
                                        isUpdate={isUpdate}
                                        setData={setData}
                                    />
                                )}
                                {step === "bank-detail" && (
                                    <BankDetails
                                        setStep={setStep}
                                        setMainStep={setMainStep}
                                        bankDetail={bankDetail}
                                        setBankDetail={setBankDetail}
                                        isUpdate={isUpdate}
                                        setData={setData}
                                    />
                                )}
                                {step === "varification" && (
                                    <SecureAccount setStep={setStep} setMainStep={setMainStep} SetSecureAccount={SetSecureAccount} isUpdate={isUpdate} setData={setData}/>
                                )}
                                {step === "taxCalc" && (
                                    <TaxCalculation setStep={setStep} setMainStep={setMainStep} />
                                )}
                                {step === "climate" && (
                                    <ClimateStep setStep={setStep} setMainStep={setMainStep} />
                                )}
                                {step === "Summary" && (
                                    <StepSummary
                                        setStep={setStep}
                                        setMainStep={setMainStep}
                                        isUpdate={isUpdate}
                                        setIsUpdate={setIsUpdate}
                                        businessType={businessType}
                                        businessDetail={businessDetail}
                                        setBusinessDetail={setBusinessDetail}
                                        businessRepresent={businessRepresent}
                                        setBusinessRepresent={setBusinessRepresent}
                                        fullfillmentDetail={fullfillmentDetail}
                                        setFullfillmentDetail={setFullfillmentDetail}
                                        businessOwner={businessOwner}
                                        setBusinessOwner={setBusinessOwner}
                                        publicDetail={publicDetail}
                                        setPublicDetail={setPublicDetail}
                                        bankDetail={bankDetail}
                                        setBankDetail={setBankDetail}
                                        secureAccount={secureAccount}
                                        SetSecureAccount={SetSecureAccount}
                                        data={data}
                                        setData={setData}
                                    />
                                )}
                            </div>
                            <div className="fixed top-[65px] lg:left-[310px] left-0 bg-white h-full lg:w-[460px] w-full"></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ActivePayment